// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 샘플데이터 생성 화면 */

.sd-init-loading {
  text-align: center;
  color: #888;
  padding: 40px 0;
  font-size: 14px;
}

/* ── 좌우 분할 ── */
.sd-split {
  display: flex;
  height: 100%;
  min-height: 0;
  gap: 0;
  overflow: hidden;
}

/* ── 패널 공통 ── */
.sd-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 8px 12px;
  overflow-y: auto;
  min-height: 0;
}

.sd-panel-left  { flex-shrink: 0; width: 30%; min-width: 260px; max-width: 360px; }
.sd-panel-right { flex: 1 1; min-width: 0; }

/* ── 구분선 ── */
.sd-resizer {
  flex-shrink: 0;
  width: 6px;
  background: #e0e4ea;
  border-radius: 3px;
  align-self: stretch;
}

/* ── 카드 공통 ── */
.sd-card {
  border: 1px solid #dde2ef;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  flex-shrink: 0;
}

.sd-card-grow {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sd-card-grow .sd-card-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

.sd-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 14px;
  background: #f0f2f8;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  border-bottom: 1px solid #dde2ef;
  gap: 8px;
  flex-shrink: 0;
}

.sd-card-body { padding: 10px 14px; }

/* ── 설정 카드 ── */
.sd-setting-card {
  border: 1px solid #dde2ef;
  border-radius: 6px;
  background: #fff;
  padding: 10px 14px;
  flex-shrink: 0;
}

/* ── 행 레이아웃 ── */
.sd-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 13px;
}
.sd-row:last-child { margin-bottom: 0; }

.sd-label {
  width: 76px;
  color: #555;
  flex-shrink: 0;
  font-weight: 500;
  font-size: 12px;
}

.sd-fixed-val {
  font-size: 12px;
  color: #333;
  font-family: monospace;
  background: #f4f5f8;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #e0e4ea;
}

.sd-input-num {
  width: 68px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
}
.sd-input-num:focus { outline: none; border-color: #4a90e2; }
.sd-input-num:disabled { background: #f5f5f5; color: #aaa; }

.sd-ratio-hint { font-size: 12px; color: #888; white-space: nowrap; }

/* ── 계좌 체크박스 리스트 ── */
.sd-acct-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.sd-acct-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.sd-acct-item input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: #4a90e2;
  flex-shrink: 0;
}
.sd-acct-item input:disabled { cursor: default; }

.sd-empty-hint { font-size: 13px; color: #999; margin: 0; }

/* ── 계좌명 매핑 테이블 ── */
.sd-map-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.sd-map-table th {
  padding: 5px 8px;
  background: #f6f8fa;
  border-bottom: 1px solid #d0d7de;
  text-align: left;
  font-weight: 600;
  color: #444;
  font-size: 12px;
}
.sd-map-table td {
  padding: 4px 4px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}
.sd-map-table tr:last-child td { border-bottom: none; }

.sd-map-orig {
  padding-left: 8px !important;
  color: #555;
  font-size: 12px;
  white-space: nowrap;
}

.sd-map-input {
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  box-sizing: border-box;
}
.sd-map-input:focus  { outline: none; border-color: #4a90e2; }
.sd-map-input:disabled { background: #f5f5f5; color: #aaa; }

/* ── 미니 버튼 (카드헤더 내) ── */
.sd-mini-btn {
  padding: 2px 8px;
  font-size: 11px;
  border: 1px solid #c0c8d8;
  border-radius: 3px;
  background: #fff;
  color: #444;
  cursor: pointer;
  transition: background 0.12s;
}
.sd-mini-btn:hover    { background: #eaf0fb; }
.sd-mini-btn:disabled { color: #bbb; cursor: default; }

/* ── 하단 액션 영역 ── */
.sd-action-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 6px 0 4px;
  flex-shrink: 0;
}

.sd-warn {
  font-size: 12px;
  color: #e07000;
  margin: 0;
  font-weight: 500;
  text-align: center;
}

.sd-error-msg {
  font-size: 12px;
  color: #c0392b;
  margin: 0;
  text-align: center;
  word-break: break-word;
}

/* ── 버튼 ── */
.sd-btn {
  padding: 7px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s;
}
.sd-btn:disabled { opacity: 0.5; cursor: default; }

.sd-btn-primary {
  background: #4a90e2;
  color: #fff;
  border-color: #4a90e2;
}
.sd-btn-primary:hover:not(:disabled) { background: #357abd; border-color: #357abd; }

.sd-btn-outline {
  background: #fff;
  color: #555;
  border-color: #c0c8d8;
}
.sd-btn-outline:hover:not(:disabled) { background: #f0f2f8; }

.sd-gen-btn {
  padding: 9px 28px !important;
  font-size: 14px !important;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 스피너 */
.sd-spinner {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: sd-spin 0.7s linear infinite;
  flex-shrink: 0;
}
@keyframes sd-spin { to { transform: rotate(360deg); } }

/* ── 처리 현황 테이블 ── */
.sd-progress-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.sd-progress-table th {
  padding: 5px 8px;
  background: #f6f8fa;
  border-bottom: 2px solid #d0d7de;
  font-weight: 600;
  color: #444;
  font-size: 12px;
  white-space: nowrap;
}
.sd-progress-table td {
  padding: 4px 8px;
  border-bottom: 1px solid #f0f2f6;
  vertical-align: middle;
}
.sd-progress-table tr:last-child td { border-bottom: none; }
.sd-progress-table tr:hover td { background: #f8f9fb; }
.sd-pt-row-err td { background: #fff5f5 !important; }

.sd-pt-no    { width: 28px; text-align: center; color: #888; font-size: 12px; }
.sd-pt-desc  { width: auto; }
.sd-pt-table { width: 180px; font-size: 12px; color: #555; }
.sd-pt-table code {
  font-family: 'Consolas', monospace;
  font-size: 11px;
  background: #f0f2f6;
  padding: 1px 4px;
  border-radius: 3px;
  color: #3a4a6b;
}
.sd-pt-cnt   { width: 52px; text-align: right; font-size: 12px; color: #27ae60; font-weight: 600; }
.sd-pt-stat  { width: 36px; text-align: center; }

/* ── 상태 아이콘 ── */
.sd-icon-wait    { color: #bbb; font-size: 12px; }
.sd-icon-done    { font-size: 14px; }
.sd-icon-err     { font-size: 14px; }

.sd-icon-running {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #4a90e2;
  border-top-color: transparent;
  border-radius: 50%;
  animation: sd-spin 0.6s linear infinite;
  vertical-align: middle;
}

/* ── 진행 로그 ── */
.sd-log-area {
  font-family: 'Consolas', 'D2Coding', monospace;
  font-size: 12px;
  background: #1e1e2e;
  color: #d4d4d4;
  padding: 10px 14px !important;
  line-height: 1.65;
  min-height: 80px;
}

.sd-log-line { white-space: pre-wrap; word-break: break-all; }
.sd-log-line:first-child { margin-top: 0; }

.sd-log-empty {
  color: #666;
  font-size: 12px;
  margin: 0;
  font-style: italic;
}

/* ── 오버레이 / 팝업 ── */
.sd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.sd-popup {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  width: 420px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sd-popup-sm { width: 300px; }

.sd-popup-hd {
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  background: #f0f2f8;
  border-bottom: 1px solid #dde2ef;
}

.sd-popup-bd {
  padding: 18px 18px 14px;
  font-size: 13px;
  line-height: 1.6;
  color: #333;
}

.sd-popup-ft {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  background: #fafbfd;
  border-top: 1px solid #eee;
}

/* ── 확인 팝업 내용 ── */
.sd-confirm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-bottom: 14px;
}
.sd-confirm-table th {
  text-align: left;
  width: 80px;
  color: #555;
  font-weight: 600;
  padding: 4px 8px 4px 0;
  vertical-align: top;
  white-space: nowrap;
}
.sd-confirm-table td {
  padding: 4px 0;
  color: #222;
  vertical-align: top;
}

.sd-confirm-acct-row {
  font-size: 12px;
  margin-bottom: 2px;
}
.sd-confirm-arrow { color: #555; font-size: 12px; }

.sd-confirm-warn {
  font-size: 12px;
  color: #c0392b;
  font-weight: 600;
  margin: 0;
  padding: 10px 12px;
  background: #fff5f5;
  border: 1px solid #fcc;
  border-radius: 5px;
  line-height: 1.6;
}

/* ── 완료 팝업 내용 ── */
.sd-complete-bd {
  text-align: center;
  padding: 24px 18px 18px !important;
}

.sd-complete-icon {
  font-size: 36px;
  margin-bottom: 10px;
}

.sd-complete-msg {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 6px;
}

.sd-complete-total {
  font-size: 13px;
  color: #27ae60;
  font-weight: 700;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/SampleDataPage.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,MAAM;EACN,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA,kBAAkB,cAAc,EAAE,UAAU,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAClF,kBAAkB,SAAO,EAAE,YAAY,EAAE;;AAEzC,cAAc;AACd;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,QAAQ;EACR,cAAc;AAChB;;AAEA,gBAAgB,kBAAkB,EAAE;;AAEpC,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;AACA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA,sBAAsB,aAAa,EAAE,qBAAqB,EAAE;AAC5D,yBAAyB,mBAAmB,EAAE,WAAW,EAAE;;AAE3D,iBAAiB,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEpE,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA,+BAA+B,eAAe,EAAE;;AAEhD,iBAAiB,eAAe,EAAE,WAAW,EAAE,SAAS,EAAE;;AAE1D,qBAAqB;AACrB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;AACA,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA,uBAAuB,aAAa,EAAE,qBAAqB,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,WAAW,EAAE;;AAE3D,yBAAyB;AACzB;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,WAAW,EAAE,eAAe,EAAE;;AAEtD,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gDAAgD;AAClD;AACA,mBAAmB,YAAY,EAAE,eAAe,EAAE;;AAElD;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;;AAEnF;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA,uCAAuC,mBAAmB,EAAE;;AAE5D;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,QAAQ;AACR;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,iCAAiC,mBAAmB,EAAE;AACtD,oBAAoB,8BAA8B,EAAE;;AAEpD,eAAe,WAAW,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;AAC9E,eAAe,WAAW,EAAE;AAC5B,eAAe,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE;AAC3D;EACE,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,eAAe,WAAW,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAClG,eAAe,WAAW,EAAE,kBAAkB,EAAE;;AAEhD,iBAAiB;AACjB,mBAAmB,WAAW,EAAE,eAAe,EAAE;AACjD,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;;AAEpC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe,qBAAqB,EAAE,qBAAqB,EAAE;AAC7D,2BAA2B,aAAa,EAAE;;AAE1C;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA,eAAe,YAAY,EAAE;;AAE7B;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA,oBAAoB,WAAW,EAAE,eAAe,EAAE;;AAElD;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["/* 샘플데이터 생성 화면 */\n\n.sd-init-loading {\n  text-align: center;\n  color: #888;\n  padding: 40px 0;\n  font-size: 14px;\n}\n\n/* ── 좌우 분할 ── */\n.sd-split {\n  display: flex;\n  height: 100%;\n  min-height: 0;\n  gap: 0;\n  overflow: hidden;\n}\n\n/* ── 패널 공통 ── */\n.sd-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 8px 12px;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.sd-panel-left  { flex-shrink: 0; width: 30%; min-width: 260px; max-width: 360px; }\n.sd-panel-right { flex: 1; min-width: 0; }\n\n/* ── 구분선 ── */\n.sd-resizer {\n  flex-shrink: 0;\n  width: 6px;\n  background: #e0e4ea;\n  border-radius: 3px;\n  align-self: stretch;\n}\n\n/* ── 카드 공통 ── */\n.sd-card {\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  background: #fff;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.sd-card-grow {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.sd-card-grow .sd-card-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.sd-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 14px;\n  background: #f0f2f8;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n  border-bottom: 1px solid #dde2ef;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.sd-card-body { padding: 10px 14px; }\n\n/* ── 설정 카드 ── */\n.sd-setting-card {\n  border: 1px solid #dde2ef;\n  border-radius: 6px;\n  background: #fff;\n  padding: 10px 14px;\n  flex-shrink: 0;\n}\n\n/* ── 행 레이아웃 ── */\n.sd-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n.sd-row:last-child { margin-bottom: 0; }\n\n.sd-label {\n  width: 76px;\n  color: #555;\n  flex-shrink: 0;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.sd-fixed-val {\n  font-size: 12px;\n  color: #333;\n  font-family: monospace;\n  background: #f4f5f8;\n  padding: 3px 8px;\n  border-radius: 4px;\n  border: 1px solid #e0e4ea;\n}\n\n.sd-input-num {\n  width: 68px;\n  padding: 4px 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  text-align: right;\n}\n.sd-input-num:focus { outline: none; border-color: #4a90e2; }\n.sd-input-num:disabled { background: #f5f5f5; color: #aaa; }\n\n.sd-ratio-hint { font-size: 12px; color: #888; white-space: nowrap; }\n\n/* ── 계좌 체크박스 리스트 ── */\n.sd-acct-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.sd-acct-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n  user-select: none;\n}\n.sd-acct-item input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  accent-color: #4a90e2;\n  flex-shrink: 0;\n}\n.sd-acct-item input:disabled { cursor: default; }\n\n.sd-empty-hint { font-size: 13px; color: #999; margin: 0; }\n\n/* ── 계좌명 매핑 테이블 ── */\n.sd-map-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.sd-map-table th {\n  padding: 5px 8px;\n  background: #f6f8fa;\n  border-bottom: 1px solid #d0d7de;\n  text-align: left;\n  font-weight: 600;\n  color: #444;\n  font-size: 12px;\n}\n.sd-map-table td {\n  padding: 4px 4px;\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n.sd-map-table tr:last-child td { border-bottom: none; }\n\n.sd-map-orig {\n  padding-left: 8px !important;\n  color: #555;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.sd-map-input {\n  width: 100%;\n  padding: 4px 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n.sd-map-input:focus  { outline: none; border-color: #4a90e2; }\n.sd-map-input:disabled { background: #f5f5f5; color: #aaa; }\n\n/* ── 미니 버튼 (카드헤더 내) ── */\n.sd-mini-btn {\n  padding: 2px 8px;\n  font-size: 11px;\n  border: 1px solid #c0c8d8;\n  border-radius: 3px;\n  background: #fff;\n  color: #444;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.sd-mini-btn:hover    { background: #eaf0fb; }\n.sd-mini-btn:disabled { color: #bbb; cursor: default; }\n\n/* ── 하단 액션 영역 ── */\n.sd-action-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0 4px;\n  flex-shrink: 0;\n}\n\n.sd-warn {\n  font-size: 12px;\n  color: #e07000;\n  margin: 0;\n  font-weight: 500;\n  text-align: center;\n}\n\n.sd-error-msg {\n  font-size: 12px;\n  color: #c0392b;\n  margin: 0;\n  text-align: center;\n  word-break: break-word;\n}\n\n/* ── 버튼 ── */\n.sd-btn {\n  padding: 7px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s, border-color 0.15s;\n}\n.sd-btn:disabled { opacity: 0.5; cursor: default; }\n\n.sd-btn-primary {\n  background: #4a90e2;\n  color: #fff;\n  border-color: #4a90e2;\n}\n.sd-btn-primary:hover:not(:disabled) { background: #357abd; border-color: #357abd; }\n\n.sd-btn-outline {\n  background: #fff;\n  color: #555;\n  border-color: #c0c8d8;\n}\n.sd-btn-outline:hover:not(:disabled) { background: #f0f2f8; }\n\n.sd-gen-btn {\n  padding: 9px 28px !important;\n  font-size: 14px !important;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* 스피너 */\n.sd-spinner {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  border: 2px solid rgba(255,255,255,0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: sd-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n@keyframes sd-spin { to { transform: rotate(360deg); } }\n\n/* ── 처리 현황 테이블 ── */\n.sd-progress-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.sd-progress-table th {\n  padding: 5px 8px;\n  background: #f6f8fa;\n  border-bottom: 2px solid #d0d7de;\n  font-weight: 600;\n  color: #444;\n  font-size: 12px;\n  white-space: nowrap;\n}\n.sd-progress-table td {\n  padding: 4px 8px;\n  border-bottom: 1px solid #f0f2f6;\n  vertical-align: middle;\n}\n.sd-progress-table tr:last-child td { border-bottom: none; }\n.sd-progress-table tr:hover td { background: #f8f9fb; }\n.sd-pt-row-err td { background: #fff5f5 !important; }\n\n.sd-pt-no    { width: 28px; text-align: center; color: #888; font-size: 12px; }\n.sd-pt-desc  { width: auto; }\n.sd-pt-table { width: 180px; font-size: 12px; color: #555; }\n.sd-pt-table code {\n  font-family: 'Consolas', monospace;\n  font-size: 11px;\n  background: #f0f2f6;\n  padding: 1px 4px;\n  border-radius: 3px;\n  color: #3a4a6b;\n}\n.sd-pt-cnt   { width: 52px; text-align: right; font-size: 12px; color: #27ae60; font-weight: 600; }\n.sd-pt-stat  { width: 36px; text-align: center; }\n\n/* ── 상태 아이콘 ── */\n.sd-icon-wait    { color: #bbb; font-size: 12px; }\n.sd-icon-done    { font-size: 14px; }\n.sd-icon-err     { font-size: 14px; }\n\n.sd-icon-running {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #4a90e2;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: sd-spin 0.6s linear infinite;\n  vertical-align: middle;\n}\n\n/* ── 진행 로그 ── */\n.sd-log-area {\n  font-family: 'Consolas', 'D2Coding', monospace;\n  font-size: 12px;\n  background: #1e1e2e;\n  color: #d4d4d4;\n  padding: 10px 14px !important;\n  line-height: 1.65;\n  min-height: 80px;\n}\n\n.sd-log-line { white-space: pre-wrap; word-break: break-all; }\n.sd-log-line:first-child { margin-top: 0; }\n\n.sd-log-empty {\n  color: #666;\n  font-size: 12px;\n  margin: 0;\n  font-style: italic;\n}\n\n/* ── 오버레이 / 팝업 ── */\n.sd-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.sd-popup {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.25);\n  width: 420px;\n  max-width: 90vw;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.sd-popup-sm { width: 300px; }\n\n.sd-popup-hd {\n  padding: 14px 18px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a2e;\n  background: #f0f2f8;\n  border-bottom: 1px solid #dde2ef;\n}\n\n.sd-popup-bd {\n  padding: 18px 18px 14px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.sd-popup-ft {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 18px;\n  background: #fafbfd;\n  border-top: 1px solid #eee;\n}\n\n/* ── 확인 팝업 내용 ── */\n.sd-confirm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  margin-bottom: 14px;\n}\n.sd-confirm-table th {\n  text-align: left;\n  width: 80px;\n  color: #555;\n  font-weight: 600;\n  padding: 4px 8px 4px 0;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.sd-confirm-table td {\n  padding: 4px 0;\n  color: #222;\n  vertical-align: top;\n}\n\n.sd-confirm-acct-row {\n  font-size: 12px;\n  margin-bottom: 2px;\n}\n.sd-confirm-arrow { color: #555; font-size: 12px; }\n\n.sd-confirm-warn {\n  font-size: 12px;\n  color: #c0392b;\n  font-weight: 600;\n  margin: 0;\n  padding: 10px 12px;\n  background: #fff5f5;\n  border: 1px solid #fcc;\n  border-radius: 5px;\n  line-height: 1.6;\n}\n\n/* ── 완료 팝업 내용 ── */\n.sd-complete-bd {\n  text-align: center;\n  padding: 24px 18px 18px !important;\n}\n\n.sd-complete-icon {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n\n.sd-complete-msg {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin: 0 0 6px;\n}\n\n.sd-complete-total {\n  font-size: 13px;\n  color: #27ae60;\n  font-weight: 700;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
